import { Breakpoint } from '@altibox/design-system-component-lib';
import React, { FC } from 'react';

import { Link } from 'src/components/link';
import { SummaryInformationCard, SummaryItem } from 'src/components/summary-information-card';
import { SummaryInformationRow, SummaryInformationRowProps } from 'src/components/summary-information-row';
import { config } from 'src/config/config';
import { i18n } from 'src/i18n';
import { selectSelectedServiceLocationOrThrow } from 'src/state/address/selectors';
import { useAppSelector } from 'src/state/thunk-api';
import { formatCurrency } from 'src/utils/currency-utils';
import { OrderInformationUtils } from 'src/utils/order-information-utils';

export const DeliveryInformation: FC = () => {
  const serviceLocation = useAppSelector(selectSelectedServiceLocationOrThrow);

  const summaryItems: SummaryItem[] = [
    {
      label: i18n.page.summary.deliveryInformation.totalPrice,
      value: formatCurrency(0),
    },
  ];

  const renderLinkToDeliveryPage = (): React.ReactNode => (
    <Link variant="paragraph3" maxBreakpoint={Breakpoint.TABLET} href={config.PICK_UP_URL} target="_blank">
      {i18n.page.summary.deliveryInformation.moreInformation}
    </Link>
  );

  const renderDeliveryInformation = () => {
    const deliveryInformation: SummaryInformationRowProps[] = [
      {
        label: i18n.page.summary.deliveryInformation.deliveryAddress,
        value: OrderInformationUtils.getShortAddress(serviceLocation),
        isValueSensitive: true,
      },
      {
        label: i18n.page.summary.deliveryInformation.chosenMethod,
        note: {
          label: i18n.page.summary.deliveryInformation.methodDescription,
          value: renderLinkToDeliveryPage(),
        },
      },
    ];

    return deliveryInformation.map((item, index) => <SummaryInformationRow key={index} {...item} />);
  };

  return (
    <SummaryInformationCard
      title={i18n.page.summary.deliveryInformation.title}
      content={<>{renderDeliveryInformation()}</>}
      summaryItems={summaryItems}
    />
  );
};
